import { useState, useEffect } from 'react'
import { LogoHeaderProps } from '../../../components/LogoHeader'

export const StoreLogo: React.FC<LogoHeaderProps> = (
  props: LogoHeaderProps
) => {
  const [textColor, setTextColor] = useState(null)

  useEffect(() => {
    setTextColor(props.theme === 'light' ? '#000' : '#fff')
  }, [props.theme])
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.width}
      height={props.height}
      viewBox="0 0 296 93"
    >
      <defs>
        <linearGradient
          id="d7u5a"
          x1="20.41"
          x2="57.78"
          y1="66.49"
          y2="-10.16"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#a03c95" stopOpacity="0" />
          <stop offset="1" stopColor="#49c7f2" />
        </linearGradient>
        <linearGradient
          id="d7u5b"
          x1="45.6"
          x2="82.99"
          y1="78.78"
          y2="2.12"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#a03c95" stopOpacity="0" />
          <stop offset="1" stopColor="#49c7f2" />
        </linearGradient>
        <linearGradient
          id="d7u5c"
          x1="-4.84"
          x2="32.54"
          y1="54.17"
          y2="-22.47"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#a03c95" stopOpacity="0" />
          <stop offset="1" stopColor="#49c7f2" />
        </linearGradient>
      </defs>
      <g>
        <g>
          <g>
            <g>
              <g>
                <path
                  fill="#b700ba"
                  d="M38.27.14c9.863 3.982 16.416 11.104 16.013 22.603-.102 2.893-.93 5.98-2.232 8.572-4.758 9.484-9.882 18.785-14.813 28.184-1.863 3.55-4.591 5.733-8.607 6.442-5.46.963-11.629-3.705-12.058-9.248-.2-2.602.243-5.001 1.5-7.34A4819.878 4819.878 0 0 0 35.256 17.01c1.84-3.486 3.346-7.102 3.938-11.056.305-2.04.022-3.932-.925-5.815z"
                />
              </g>
              <g>
                <path
                  fill="#b700ba"
                  d="M69.44.075c6.233 2.749 11.39 6.236 14.123 12.443 2.844 6.457 2.775 12.91-.444 19.156-4.905 9.52-10.026 18.928-15.01 28.407-2.436 4.637-7.07 6.3-10.577 5.927-4.96-.526-8.591-3.763-9.63-8.493-.57-2.594-.231-5.142 1.043-7.535 5.665-10.64 11.319-21.288 16.968-31.937 1.964-3.705 3.713-7.486 4.402-11.683.347-2.119.214-4.138-.875-6.285z"
                />
              </g>
              <g>
                <path
                  fill="#b700ba"
                  d="M6.99 0c5.19 2.438 9.827 5.043 12.725 9.84 4.598 7.616 4.734 15.365.335 23.073-2.302 4.035-6.075 5.7-10.618 5.248-4.506-.447-8.212-3.834-9.157-8.273-.57-2.678-.276-5.33 1.08-7.828 2.327-4.285 4.806-8.51 6.056-13.287C8.163 5.9 8.653 3.03 6.99 0z"
                />
              </g>
            </g>
            <g>
              <g>
                <path
                  fill="url(#d7u5a)"
                  d="M38.27.14c9.863 3.982 16.416 11.104 16.013 22.603-.102 2.893-.93 5.98-2.232 8.572-4.758 9.484-9.882 18.785-14.813 28.184-1.863 3.55-4.591 5.733-8.607 6.442-5.46.963-11.629-3.705-12.058-9.248-.2-2.602.243-5.001 1.5-7.34A4819.878 4819.878 0 0 0 35.256 17.01c1.84-3.486 3.346-7.102 3.938-11.056.305-2.04.022-3.932-.925-5.815z"
                />
              </g>
              <g>
                <path
                  fill="url(#d7u5b)"
                  d="M69.44.075c6.233 2.749 11.39 6.236 14.123 12.443 2.844 6.457 2.775 12.91-.444 19.156-4.905 9.52-10.026 18.928-15.01 28.407-2.436 4.637-7.07 6.3-10.577 5.927-4.96-.526-8.591-3.763-9.63-8.493-.57-2.594-.231-5.142 1.043-7.535 5.665-10.64 11.319-21.288 16.968-31.937 1.964-3.705 3.713-7.486 4.402-11.683.347-2.119.214-4.138-.875-6.285z"
                />
              </g>
              <g>
                <path
                  fill="url(#d7u5c)"
                  d="M6.99 0c5.19 2.438 9.827 5.043 12.725 9.84 4.598 7.616 4.734 15.365.335 23.073-2.302 4.035-6.075 5.7-10.618 5.248-4.506-.447-8.212-3.834-9.157-8.273-.57-2.678-.276-5.33 1.08-7.828 2.327-4.285 4.806-8.51 6.056-13.287C8.163 5.9 8.653 3.03 6.99 0z"
                />
              </g>
            </g>
            <g>
              <g>
                <text
                  fill={textColor}
                  style={{ lineHeight: '40px', fontKerning: 'normal' }}
                  dominantBaseline="text-before-edge"
                  fontFamily="Avenir, Avenir-Medium, AvenirNext"
                  fontSize="33"
                  transform="translate(98 2)"
                >
                  <tspan letterSpacing="7.59">WORSHI</tspan>
                  <tspan>P</tspan>
                </text>
              </g>
            </g>
            <g>
              <g>
                <text
                  fill={textColor}
                  style={{ lineHeight: '17px', fontKerning: 'normal' }}
                  dominantBaseline="text-before-edge"
                  fontFamily="Avenir, Avenir-Book, AvenirNext"
                  fontSize="14"
                  transform="translate(107 44)"
                >
                  <tspan letterSpacing="24.5">ONLIN</tspan>
                  <tspan>E</tspan>
                </text>
              </g>
            </g>
          </g>
          <g>
            <g>
              <path
                fill="#7d6bcc"
                d="M162 93c-5.523 0-10-4.477-10-10v-1c0-5.523 4.477-10 10-10h121v11c0 5.523-4.477 10-10 10z"
              />
            </g>
            <g>
              <g>
                <text
                  fill={textColor}
                  style={{ fontKerning: 'normal' }}
                  dominantBaseline="text-before-edge"
                  fontFamily="AvenirNext, AvenirNext-Bold"
                  fontSize="10"
                  fontStyle="none"
                  fontWeight="700"
                  letterSpacing="5"
                  transform="translate(192 76)"
                >
                  <tspan>STORE</tspan>
                </text>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  )
}

export default StoreLogo
